<template>
<div
  class="el-file-drop"
  ref="dropArea"
  @click="openFileBrowse"
  >

  <!-- Hidden upload file form -->
  <div class="form-wrapper">
    <form>
      <p v-if="caption !== ''">{{caption}}</p>

      <input
        type="file"
        class="file-element"
        id="fileInput"
        ref="fileInput"
        multiple
        :accept="accept"
        @change="handleBrowse"
        >

      <label
        class="browse-button"
        for="fileInput"
        >
        Select some files
      </label>
    </form>
  </div>

  <div
    class="animation"
    >
    <h3>Drop .zip-file</h3>
    <p>or click to browse</p>
  </div>
</div>
</template>
<script>

export default {
  props: {
    caption: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: 'audio/*'
    }
  },
  data () {
    return {}
  },
  computed: {
    dropArea () {
      return this.$refs.dropArea
    }
  },
  mounted () {
    // Prevent default drag behaviors
    ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      this.dropArea.addEventListener(eventName, this.preventDefaults, false)
      document.body.addEventListener(eventName, this.preventDefaults, false)
    })

    // Highlight drop area when item is dragged over it
    ;['dragenter', 'dragover'].forEach(eventName => {
      this.dropArea.addEventListener(eventName, this.highlight, false)
    })

    ;['dragleave', 'drop'].forEach(eventName => {
      this.dropArea.addEventListener(eventName, this.unhighlight, false)
    })

    // Handle dropped files
    this.dropArea.addEventListener('drop', this.handleDrop, false)
  },
  methods: {
    preventDefaults (e) {
      e.preventDefault()
      e.stopPropagation()
    },
    highlight (e) {
      this.dropArea.classList.add('highlight')
    },
    unhighlight (e) {
      this.dropArea.classList.remove('highlight')
    },
    handleDrop (e) {
      const dt = e.dataTransfer
      const files = dt.files

      this.handleFiles(files)
    },
    handleBrowse () {
      const files = [...this.$refs.fileInput.files]
      this.handleFiles(files)
    },
    handleFiles (files) {
      files = [...files]

      this.$emit('select', files)
    },
    openFileBrowse () {
      this.$refs.fileInput.click()
    }
  }
}
</script>
<style lang="less" scoped>
  .el-file-drop {
    background-color: #ffffff;
    border: 1px dashed #979797;
    border-radius: 10px;
    width: 100%;
    height: 100%;
    max-height: 300px;
    cursor: pointer;
    transition: height 0.5s ease-in-out;

    .note {
      width: 500px;
      margin: 50px auto;
      font-size: 1.1em;
      color: #333;
      text-align: justify;
    }

    .form-wrapper {
      visibility: hidden;
      display: none;
    }

    .browse-button {
      cursor: pointer;
    }

    .file-element {
      display: none;
    }

    .upload-icon {
      width: 213px;
      margin: 20px auto auto auto;
    }

    h3, p {
      color: #647EB6;
      width: 100%;
      text-align: center;
      padding: 0px 15px;
      max-width: 150px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .el-file-drop.highlight {
    border: 1px solid #6C85BC;
    background-color: #F4F6FB;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  }

  .animation {
    transition: all 0.5s ease-in-out;
  }
</style>
